import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlayLessonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"play_lesson"}/>
}
